import { useSuspenseQuery } from '@tanstack/react-query'
import ms from 'ms'

import { QUERY_KEYS } from '../constants/queryKeys'
import userService from '../lib/services/userService'
import { setSession } from '../store/slices/sessionSlice'
import { useAppDispatch } from './useAppDispatch'

export function useSessionQuery() {
  const dispatch = useAppDispatch()

  return useSuspenseQuery({
    queryKey: QUERY_KEYS.currentSession,
    staleTime: ms('2m'),
    queryFn: async () => {
      const session = await userService.getSession()

      dispatch(setSession(session || undefined))

      return session
    },
  })
}
